// const testItem = {
//   id: "imported-116",
//   customizations: "",
//   isHidden: false,
//   isOem: false,
//   legacyName: "Weld Inspection",
//   name: "Weld inspection",
//   parents: [
//     "imported-5",
//     "imported-8",
//     "imported-11",
//     "imported-14",
//     "imported-16",
//     "imported-17",
//     "imported-19",
//     "imported-21",
//     "imported-23",
//     "imported-34"
//   ],
//   type: "application",
//   typeName: "3. Application",
//   value: 56
// };

export const orderSegmentationFilter = ({
  isOem = false,
  parentId = undefined,
  type = undefined
} = {}) => item => {
  const isSelectedOemSetting =
    (item.isOem === isOem && item.type === "businessLine") ||
    item.type !== "businessLine";
  const hasParentSelected =
    (item.parents.length === 0 &&
      parentId === undefined &&
      item.type === "businessLine") ||
    item.parents.includes(parentId);

  const result =
    type === item.type && isSelectedOemSetting && hasParentSelected;

  return result;
};
